// extracted by mini-css-extract-plugin
export default {"addToCartControl":"V1-z","giftCard":"W1-z","btnContainer":"X1-z","cartButton":"Y1-z","disabled":"Z1-z"};